export default __webpack_public_path__ + "static/media/grue3.04ab2b60.png";